import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  "class": "dashboard fs_box_wrapper"
};
var _hoisted_2 = {
  "class": "fs_box fs_dashboard_box fs_box_narrow"
};
var _hoisted_3 = {
  "class": "fs_box_header",
  style: {
    "padding": "10px 15px",
    "font-size": "16px"
  }
};
var _hoisted_4 = {
  "class": "fs_box_actions"
};
var _hoisted_5 = {
  "class": "fs_box_body fs_padded_20"
};
var _hoisted_6 = {
  "class": "fframe_pagination_wrapper",
  style: {
    "margin-top": "20px",
    "text-align": "right"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_popconfirm = _resolveComponent("el-popconfirm");
  var _component_el_table = _resolveComponent("el-table");
  var _component_pagination = _resolveComponent("pagination");
  var _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    "class": "fs_box_head"
  }, [_createElementVNode("h3", null, "API Integrations")], -1 /* HOISTED */)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
    to: {
      name: 'new_integration',
      query: {
        integration_key: 'thrivecart'
      }
    },
    "class": "el-button el-button--primary el-button--small btn_link"
  }, {
    "default": _withCtx(function () {
      return _cache[1] || (_cache[1] = [_createTextVNode("Connect New API ")]);
    }),
    _: 1 /* STABLE */
  })])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_table, {
    stripe: "",
    border: "",
    data: $data.integrations
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        width: 80,
        label: "ID",
        prop: "id"
      }), _createVNode(_component_el_table_column, {
        label: "Title",
        prop: "title"
      }), _createVNode(_component_el_table_column, {
        width: 150,
        label: "Provider",
        prop: "provider"
      }), _createVNode(_component_el_table_column, {
        width: 100,
        label: "Status",
        prop: "status"
      }), _createVNode(_component_el_table_column, {
        label: "Actions",
        width: "180"
      }, {
        "default": _withCtx(function (scope) {
          return [_createVNode(_component_router_link, {
            to: {
              name: 'view_integration',
              params: {
                id: scope.row.id
              }
            }
          }, {
            "default": _withCtx(function () {
              return _cache[3] || (_cache[3] = [_createElementVNode("i", {
                "class": "el-icon-view"
              }, null, -1 /* HOISTED */)]);
            }),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]), _createVNode(_component_el_popconfirm, {
            "confirm-button-text": "Yes, Delete this",
            "cancel-button-text": "No",
            icon: "el-icon-info",
            "icon-color": "red",
            title: "Are you sure to delete this? All associate data connectors will be deleted too",
            onConfirm: function onConfirm($event) {
              return $options.deleteIntegration(scope.row.id);
            }
          }, {
            reference: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                style: {
                  "margin-left": "10px",
                  "color": "red"
                },
                type: "text",
                size: "mini",
                icon: "el-icon-delete"
              })];
            }),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onConfirm"])];
        }),
        _: 1 /* STABLE */
      })];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_pagination, {
    onFetch: _cache[0] || (_cache[0] = function ($event) {
      return $options.fetch();
    }),
    pagination: $data.pagination
  }, null, 8 /* PROPS */, ["pagination"])])])), [[_directive_loading, $data.loading]])])]);
}